import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux'
import { Button, Card, CardBody, CardHeader } from 'reactstrap'
import { getTeacherGatePassReport } from 'store/actions';
import CreateGatePassReq from './CreateGatePassReq';

const GatePassTeacher = () => {
    const dispatch = useDispatch();
    const { teacherGatePassList, loading, message, error, isCreated } = useSelector(state => state.GatePassReducer);

    const [isShowModal, setIsShowModal] = useState(false)

    useEffect(() => {
        dispatch(getTeacherGatePassReport())
    }, [])

    return (
        <div className='page-content container'>
            <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3'>
                <h6 className='text-primary mb-2 mb-md-0'>Gate Pass Report</h6>
                <Button color='primary' onClick={() => setIsShowModal(true)}>Create</Button>
            </div>

            {teacherGatePassList.map((report, index) => (
                <Card key={index} className="mb-3 shadow-sm">
                    <CardHeader className='d-flex justify-content-between flex-wrap border-bottom border-primary bg-light'>
                        <div><strong>Sr:</strong> {index + 1}</div>
                        {moment(report.created_date).isValid() && (
                            <div><strong>Date:</strong> {moment(report.created_date).format("DD/MM/YYYY")}</div>
                        )}
                    </CardHeader>

                    <CardBody>
                        <div className="d-flex flex-column flex-md-row">
                            <div className="p-1 w-100">
                                <div className='text-primary'>
                                    <strong>Reason:</strong> {report.reason}
                                </div>

                                <div className='mt-2'>
                                    {moment(report.requested_checkin).isValid() && (
                                        <div>
                                            <strong>Requested Checkin:</strong>
                                            <br />{moment(report.requested_checkin).format("DD/MM/YYYY HH:mm:ss")}
                                        </div>
                                    )}
                                    {moment(report.actual_checkin).isValid() && (
                                        <div>
                                            <strong>Actual Checkin:</strong>
                                            <br />{moment(report.actual_checkin).format("DD/MM/YYYY HH:mm:ss")}
                                        </div>
                                    )}
                                </div>

                                <div className='mt-3'>
                                    {moment(report.requested_checkout).isValid() && (
                                        <div>
                                            <strong>Requested Checkout:</strong>
                                            <br />{moment(report.requested_checkout).format("DD/MM/YYYY HH:mm:ss")}
                                        </div>
                                    )}
                                    {moment(report.actual_checkout).isValid() && (
                                        <div>
                                            <strong>Actual Checkout:</strong>
                                            <br />{moment(report.actual_checkout).format("DD/MM/YYYY HH:mm:ss")}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="p-1 flex-shrink-0 mt-2 mt-md-0 text-end text-md-start">
                                <span className={`badge ${report.status === "Approved" ? "bg-success" :
                                    report.status === "Pending" ? "bg-danger" :
                                        report.status === "Checked-In / Completed" ? "bg-secondary" :
                                            "bg-warning"
                                    }`}>
                                    {report.status}
                                </span>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            ))}


            <CreateGatePassReq
                isShowModal={isShowModal}
                setIsShowModal={setIsShowModal}
            />
        </div>

    )
}

export default GatePassTeacher